<template>
    <div class="page-table-layout" data-testid="threshold-new">
        <v-card :loading="loading" :disabled="loading" loader-height="2" class="all-width flex-card shadow-off" data-testid="threshold-new__main-card">
            <v-card-text class="page-table-layout__body" data-testid="threshold-new__main-content">
                <div class="d-flex align-center justify-space-between " data-testid="threshold-new__action-bar">
                    <div>
                        <div class="d-flex" data-testid="threshold-new__breadcrumbs">
                            <p class="mb-1" data-testid="threshold-new__breadcrumb-home">Home</p>
                            <p class="px-2 mb-1" data-testid="threshold-new__breadcrumb-separator">/</p>
                            <p class="mb-1" data-testid="threshold-new__breadcrumb-description">{{ metadata?.description }}</p>
                        </div>
                        <div class="d-flex align-center">
                            <h3 class="black--text font-weight-medium" data-testid="threshold-new__title">Threshold</h3>
                            <v-tooltip bottom content-class="tooltip-bottom">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                        data-testid="threshold-new__refresh-btn"
                                        v-bind="attrs"
                                        v-on="on"
                                        class="shadow-off ml-1" icon @click="refreshData()"><v-icon
                                        size="24" data-testid="threshold-new__refresh-icon">mdi-refresh</v-icon>
                                    </v-btn>
                                </template>
                                <span>Refresh</span>
                            </v-tooltip>
                        </div>
                    </div>
                    <div class="d-flex">
                        <!-- Clear Filter Button -->
                        <v-btn
                            v-if="hasActiveTableFilter"
                            outlined
                            small
                            class="mr-2"
                            color="primary"
                            @click="clearTableFilter()"
                            data-testid="threshold-new__toolbar-clear-filter-btn"
                        >
                            <v-icon left data-testid="threshold-new__toolbar-clear-filter-icon">mdi-filter-remove</v-icon>
                            <span>Clear Filter</span>
                        </v-btn>
                        <v-btn data-testid="threshold-new__add-btn" color="primary" class="mr-1 white--text" @click="addEditDialogue"
                            v-if="$nova.hasRight(right, 'edit') || $nova.hasRight(right, 'add')">
                            <v-icon class="mr-1" data-testid="threshold-new__add-icon">mdi-plus</v-icon>
                            <span>New</span>
                        </v-btn>
                    </div>
                </div>

                <div class="flex-fill-table">
                    <lb-datatableaction
                        ref="dataTableAction"
                        v-if="formatedDataCopy.length>0"
                        data-testid="threshold-new__datatable"
                        :headers="headers"
                        :tabledata="formatedDataCopy"
                        :displayedRowCount="paginatedItems.length"
                        :itemsperpage="itemsPerPage"
                        searchterm=""
                        :bulkActions="false"
                        @filter-item="filterPart"
                        @filter-active-change="onFilterActiveChange"
                        @clear-item="clearPart"
                    >
                    <template v-slot:tbody>
                        <tr v-for="item in paginatedItems" :key="item._id" class="cursor-pointer" :class="{ 'low-opacity': item.status === false }" data-testid="threshold-new__row">
                            <template v-for="header in headers">
                                <td v-if="header.visible && header.value !== 'action'" :key="header.value"
                                    class="px-2 single-line"
                                    :class="{ 'description-header': header.value === 'description', 'single-line': header.value !== 'description' }"
                                    data-testid="threshold-new__cell">
                                    {{ item[header.value] }}
                                </td>
                            </template>
                            <td class="d-flex align-center px-3 border-right border-left action-data" data-testid="threshold-new__row-actions">
                                <div class="d-flex align-center justify-center">
                                    <v-tooltip bottom content-class="tooltip-bottom" v-if="$nova.hasRight(right, 'edit')|| $nova.hasRight(right, 'add')">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn icon v-bind="attrs" v-on="on" @click.stop="editThreshold(item)" data-testid="threshold-new__edit-btn">
                                                <v-icon data-testid="threshold-new__edit-icon">mdi-pencil</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Edit</span>
                                    </v-tooltip>
                                    <v-tooltip bottom content-class="tooltip-bottom" v-if="!item.status">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn icon v-bind="attrs" v-on="on" @click.stop="toggleStatus(item, true)" data-testid="threshold-new__status-btn-disabled">
                                                <v-icon color="error" data-testid="threshold-new__status-icon-disabled">mdi-close-circle</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Enable</span>
                                    </v-tooltip>
                                    <v-tooltip bottom content-class="tooltip-bottom" v-else>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn icon v-bind="attrs" v-on="on" @click.stop="toggleStatus(item, false)" data-testid="threshold-new__status-btn-enabled">
                                                <v-icon color="success" data-testid="threshold-new__status-icon-enabled">mdi-check-circle</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Disable</span>
                                    </v-tooltip>
                                    <activity-log
                                    :resource-id="item._id"
                                    :row-description="item.name"
                                    data-testid="threshold-new__activity-log-btn"
                                    />
                                </div>
                            </td>
                        </tr>
                    </template>
                    </lb-datatableaction>

                    <div class="d-flex align-center justify-center" v-else data-testid="threshold-new__empty-state">
                        NO DATA
                    </div>
                </div>

            </v-card-text>
        </v-card>

        <Pagination :list="formatedData" :itemsperpage="itemsPerPage" @paginated-data="setPaginatedData" data-testid="threshold-new__pagination" />

        <lb-drawer
            v-model="locationdialog"
            :heading="locationdata._id ? 'Update Threshold' : 'Add Threshold'"
            width="600"
            :loading="locationdialogloading"
            data-testid="threshold-new__drawer"
        >
            <template v-slot:body>
                <div data-testid="threshold-new__drawer-body">
                    <v-row>
                        <v-col cols="12" class="my-0 py-1">
                            <p class="ma-0 mb-1" data-testid="threshold-new__drawer-location-label">{{$store.state.LocationHeader ? $store.state.LocationHeader : 'Location'}}</p>
                            <lb-dropdown
                                v-model="locationdata.location"
                                :items="locationList"
                                label=""
                                :error="locationdataerror.location"
                                itemtext="name"
                                itemvalue="_id"
                                :readonly="locationdata._id ? true : false"
                                :clearable="locationdata._id ? false : true"
                                data-testid="threshold-new__drawer-location-dropdown"
                            />
                        </v-col>
                        <v-col cols="12" class="my-0 py-1">
                            <p class="ma-0 mb-1" data-testid="threshold-new__drawer-threshold-label">Threshold</p>
                            <lb-number
                                v-model="locationdata.threshold"
                                label=""
                                :error="locationdataerror.threshold"
                                min="0"
                                data-testid="threshold-new__drawer-threshold-input"
                            />
                        </v-col>
                    </v-row>
                </div>
            </template>
            <template v-slot:actions>
                <v-switch
                    class="mt-0"
                    v-model="enableSwitch"
                    @onchange="toggleSwitch(locationdata)"
                    inset
                    hide-details
                    :label="null"
                    data-testid="threshold-new__drawer-enable-switch"
                >
                </v-switch>
                <span class="switch-label" data-testid="threshold-new__drawer-enable-label">
                    {{ enableSwitch === true ? 'Enable' : 'Disable' }}
                </span>
                <v-spacer></v-spacer>
                <v-btn color="primary" data-testid="threshold-new__drawer-submit-btn">
                    <span v-if="locationdata._id" @click="updateThreshold(locationdata)" class="white--text" data-testid="threshold-new__drawer-update-label">Update</span>
                    <span v-else @click="addThreshold()" class="white--text" data-testid="threshold-new__drawer-add-label">Add</span>
                </v-btn>
            </template>
        </lb-drawer>
    </div>
</template>

<script>
import Pagination from '../../components/Pagination/Pagination.vue';
import ActivityLog from '../../components/ActivityLog/ActivityLog.vue';
export default {
    data() {
        return {
            right: "financialclose_project",
            locationdialog: false,
            locationdialogloading: false,
            locationdata: {},
            locationdataerror: {},
            loading: false,
            hasActiveTableFilter: false,
            projectId: "",
            locationtypeItem: [],
            formatedData: [],
            formatedDataCopy:[],
            locationListdata: [],
            locationList: [],
            locationtypedialog: false,
            headers: [
                {
                    value: "name",
                    text: this.$store.state.LocationHeader || 'Location',
                    sortable: true,
                    filterable: true,
                    visible: true,
                },
                {
                    value: "threshold",
                    text: "Threshold",
                    sortable: true,
                    filterable: true,
                    visible: true,
                },
                {
                    value: "action",
                    text: "Action",
                    sortable: false,
                    filterable:false,
                    visible: true,
                },
            ],
            listdata: [],
            enableSwitch: true,
            metadata:[],
            itemsPerPage:16,
            paginatedItems:[]
            
        };
    },
    created() {
        this.$store.dispatch('tasks/ensureFilteredLocations', { cycleId: this.$route.params.id });
        this.refreshData();
    },
    components: {
        Pagination,
       ActivityLog
    },
    activated() {
        this.refreshData();
    },
    methods: {
        /**
         * Handler for filter-active-change event from DataTableAction
         */
        onFilterActiveChange(isActive) {
            this.hasActiveTableFilter = isActive;
        },
        /**
         * Clear table filters via DataTableAction ref
         */
        clearTableFilter() {
            if (this.$refs.dataTableAction) {
                this.$refs.dataTableAction.clearFilter();
            }
        },
                /**
         * Validate project threshold data fields before add/edit API call
         * Checks for null, undefined, empty, and length/number constraints
         * Returns an object with error messages for each invalid field
         */
        validateProjectThresholdData(data) {
            const errors = {};
            // Location validation (supports legacy name fallback for existing edit/status flows)
            if (!data.location && !data.name) {
                errors.location = 'Location is required.';
            }
            // Threshold validation: must be present, a valid number, 0 is valid, but very nonzero values are not
            const thresholdNum = Number(data.threshold);
            if (
                data.threshold === null ||
                data.threshold === undefined ||
                data.threshold === '' ||
                (typeof data.threshold === 'string' && data.threshold.trim() === '') ||
                isNaN(thresholdNum) ||
                typeof thresholdNum !== 'number' ||
                !isFinite(thresholdNum)
            ) {
                errors.threshold = 'Threshold is required and must be a valid number.';
            } else if (thresholdNum < 0) {
                errors.threshold = 'Threshold must be 0 or greater.';
            } else if (thresholdNum !== 0 && Math.abs(thresholdNum) < 1e-8) {
                errors.threshold = 'Threshold value is too or empty.';
            }
            return errors;
        },
        setPaginatedData(paginationInfo) {
            if (paginationInfo && typeof paginationInfo === 'object' && 'data' in paginationInfo) {
                this.paginatedItems = paginationInfo.data || [];
                this.page = paginationInfo.page || 1;
            } else {
                this.paginatedItems = paginationInfo || [];
            }
        },
        refreshData() {
            this.projectId = this.$route.params.id || "";
            this.hasActiveTableFilter = false;
            this.formatedData = this.formatedDataCopy;
            this.clearTableFilter();
            this.getData();
        },
        formateData() {
            let ObjectTemp = {};
            let ArrayTemp = [];
            this.listdata.forEach((item, index) => {
                ObjectTemp = {
                    __key: index,
                    __formatedkey: index,
                    _id: item._id,
                    indexno: index + 1,
                    name: item.locationName,
                    locationId: item.locationId,
                    threshold: this.formatNum(item.threshold),
                    created_at: item.created_at,
                    updated_at: item.updated_at,
                    status: item.status,
                };
                ArrayTemp.push(ObjectTemp);
            });
            this.formatedData = ArrayTemp;
            this.formatedDataCopy = ArrayTemp;
        },
        addEditDialogue() {
            this.setEligibleLocationList();
            if (this.loading || (this.locationList || []).length === 0) {
                this.$store.commit("sbInfo", "All locations already have thresholds configured.");
                return;
            }
            this.locationdialog = true;
            this.locationdata = { location: "", threshold: 0 };
            this.locationdataerror = {};
            this.locationUserList = [];
            this.customassertions = false;
        },
        async getData() {
            this.loading = true;
            await this.axios
                .post("/v2/financialclose/project/threshold/get/" + this.projectId)
                .then(async (ele) => {
                    if (ele.data.status === "success") {
                        // this.listdata = ele.data.data;
                        // this.metadata = ele.data?.metadata;
                        this.listdata = ele.data.data[0].threshold;
                        this.metadata = ele.data?.data[0].metadata;
                        
                        //Use filtered locations from Vuex if available
                        if (this.filteredLocationsFromStore.length > 0) {
                            this.locationListdata = this.filteredLocationsFromStore;
                            this.processLocationData();
                        } else {
                            // Fallback: Fetch all locations if not in Vuex
                            await this.axios
                                .post("/v2/financialclose/location/get")
                                .then((ele) => {
                                    if (ele.data.status === "success") {
                                        this.locationListdata = ele.data.data;
                                        this.processLocationData();
                                    }
                                })
                        }
                    }
                })
                .catch((err) => {
                    console.log(err);
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        processLocationData() {
            // Process location data
            this.listdata = this.listdata.filter(obj1 => {
                return this.locationListdata.filter(obj2 => {
                    if (obj2._id === obj1.location) {
                        obj1.locationName = obj2.name
                        return obj1;
                    }
                });
            })
            this.formateData()
            this.setEligibleLocationList();
            // Clear filters after new data is loaded and rendered
            this.$nextTick(() => {
                this.hasActiveTableFilter = false;
                if (this.$refs.dataTableAction) {
                    this.$refs.dataTableAction.clearFilter();
                }
            });
        },
        getConfiguredLocationIdSet() {
            const configuredLocationIds = (this.listdata || [])
                .map(item => item && item.location)
                .filter(Boolean);
            return new Set(configuredLocationIds);
        },
        getLocationIdFromName(name) {
            if (!name) return "";
            const match = (this.locationListdata || []).find(item => item.name === name);
            return match?._id || "";
        },
        setEligibleLocationList(excludedLocationId = "") {
            const configuredSet = this.getConfiguredLocationIdSet();
            if (excludedLocationId) configuredSet.delete(excludedLocationId);
            this.locationList = (this.locationListdata || []).filter(item => !configuredSet.has(item._id));
        },
        addThreshold() {
            // Validate before API call
            const errors = this.validateProjectThresholdData(this.locationdata);
            this.locationdataerror = errors;
            if (Object.keys(errors).length > 0) {
                this.$store.commit("sbError", "Please fill all required fields correctly.");
                return;
            }
            this.locationdialogloading = true;
            this.locationdata = { ...this.locationdata, 'status': this.enableSwitch }
            this.axios
                .post("/v2/financialclose/project/threshold/add/" + this.projectId, { data: this.locationdata })
                .then((ele) => {
                    if (ele.data.status === "success") {
                        this.locationdialog = false;
                        this.$store.commit("sbSuccess", ele.data.message);
                        this.refreshData();
                    } else {
                        const failureMessage = ele?.data?.message || "Failed to add threshold.";
                        const responseData = Array.isArray(ele?.data?.data) ? ele.data.data : [];
                        if (responseData.length > 0) {
                            if (responseData[0]?.index0)
                                this.locationdataerror = responseData[0].index0;
                        }
                        this.$store.commit("sbError", failureMessage);
                    }
                })
                .catch((err) => {
                    const errMessage = err?.response?.data?.message || err?.message || err || "Unknown error!";
                    this.$store.commit("sbError", errMessage);
                })
                .finally(() => {
                    this.locationdialogloading = false;
                });
        },
        editThreshold(item) {
            // Remove commas if present and convert to number
            let thresholdValue = item.threshold;
            if (typeof thresholdValue === 'string') {
                thresholdValue = Number(thresholdValue.replace(/,/g, ''));
            }
            const selectedLocationId = item.location || item.locationId || this.getLocationIdFromName(item.name);
            this.setEligibleLocationList(selectedLocationId);
            this.locationdata = { ...item, location: selectedLocationId, threshold: thresholdValue };
            this.locationdialog = true;
            this.enableSwitch = item.status
            this.locationdataerror = {};
        },
        updateThreshold(item, toggle = false) {
            // Validate before API call
            const errors = this.validateProjectThresholdData(item);
            this.locationdataerror = errors;
            console.log('errors', JSON.stringify(item), JSON.stringify(errors));
            if (Object.keys(errors).length > 0) {
                this.$store.commit("sbError", "Please fill all required fields correctly.");
                return;
            }
            this.locationdialogloading = true;
            if (!toggle) {
                item.status = this.enableSwitch
            }
            this.axios
                .post("v2/financialclose/project/threshold/edit/" + item._id, { data: item })
                .then((ele) => {
                    if (ele.data.status === "success") {
                        this.locationdialog = false;
                        this.$store.commit("sbSuccess", ele.data.message);
                        this.refreshData();
                    } else {
                        const failureMessage = ele?.data?.message || "Failed to update threshold.";
                        const responseData = Array.isArray(ele?.data?.data) ? ele.data.data : [];
                        if (responseData.length > 0) {
                            if (responseData[0]?.index0)
                                this.locationdataerror = responseData[0].index0;
                        }
                        this.$store.commit("sbError", failureMessage);
                    }
                })
                .catch((err) => {
                    const errMessage = err?.response?.data?.message || err?.message || err || "Unknown error!";
                    this.$store.commit("sbError", errMessage);
                })
                .finally(() => {
                    this.locationdialogloading = false;
                });
        },
        toggleSwitch(item) {
            item.status = this.enableSwitch
        },
        toggleStatus(item, newStatus) {
            let thresholdValue = item.threshold;
            if (typeof thresholdValue === 'string') {
                thresholdValue = Number(thresholdValue.replace(/,/g, ''));
            }
            const updatedItem = { ...item, threshold: thresholdValue, status: newStatus };
            this.updateThreshold(updatedItem, true);
        },
    filterPart(item,header){
        console.log(item,header);
        this.formatedData = this.$nova.filterByDynamicCriteria(this.formatedDataCopy, item);  
      },
    clearPart(item){
        console.log(item,"item");
        this.formatedData = this.formatedDataCopy;
      },
      formatNum(input) {
            let number = Number(input);
            if (isNaN(number) || input === null || input === undefined || input === "") {
                return "";
            }
            return number.toLocaleString("en-US");
        }
    },
    computed: {
        filteredLocationsFromStore() {
            return this.$store.getters['tasks/getFilteredLocations'] || [];
        }
    },

};
</script>

<style></style>